<div class="if-modal" (click)="onBackdropClick($event)" (keydown)="onKeydown($event)">
  <div class="if-modal-backdrop" [@modalBackdrop]="animState()"></div>
  <div
    #body
    class="if-modal-body"
    [attr.role]="dialogRole()"
    aria-modal="true"
    tabindex="-1"
    [attr.aria-labelledby]="titleId()"
    [attr.aria-describedby]="descriptionIds()"
    [attr.data-size]="size()"
    [class.if-modal-body--sized]="size() !== null"
    [@modalBody]="animState()"
    (@modalBody.done)="onBodyAnimationDone($event)">
    @if (showCloseButton()) {
      <button type="button" class="if-modal-close" aria-label="Close" appTooltip="Close" tooltipPosition="left" (click)="close()">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.75" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>
    }
    <ng-content select=".if-modal-title"></ng-content>
    <ng-content select=".if-modal-content"></ng-content>
    <ng-content select=".if-modal-actions"></ng-content>
  </div>
</div>
